<div style="height:calc(100vh - 112px); overflow-y: auto;">
  <div class="container-fluid">
    <div class="row justify-content-center pt-4">
      <div class="col-11">
        <span class="rm-title rm-title-3">Edit Email Templates</span><br/>
        <!--        <span class="rm-title rm-title-6 rm-lighter">This is the user's sent email notifications:</span>-->
      </div>
    </div>
    <div class="row justify-content-center pt-4">
      <div class="col-11">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Select Template</mat-label>
          <mat-select (selectionChange)="selectTemplate($event.value)">
            <mat-option *ngFor="let template of emailTemplates" [value]="template.key">
              <b>{{template.value}}</b> - <i>{{template.detail}}</i>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
        <mat-form-field>
          <mat-label>Select User Profile</mat-label>
          <mat-select [(value)]="selectedProfile" (selectionChange)="selectProfile($event.value)">
            <mat-option value="investor">Investors / Default User</mat-option>
            <mat-option value="issuer">Issuer</mat-option>
            <mat-option value="admin">Rondeivu Admin</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row justify-content-center pt-4" *ngIf="selectedTemplate">
      <div class="col-11">
        <form [formGroup]="emailFormGroup">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="emailSubject" placeholder="Email Subject" class="full-width"/>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Body</mat-label>
            <textarea matInput formControlName="emailBody" placeholder="Email Body" rows="10" class="full-width"></textarea>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Button Text</mat-label>
            <input matInput formControlName="buttonText" placeholder="Button Text" class="full-width"/>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Button Link</mat-label>
            <input matInput formControlName="buttonLink" placeholder="Button Link" class="full-width"/>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline" [hidden]="selectedProfile !== 'admin'">
            <mat-label>Recipient</mat-label>
            <input matInput formControlName="recipient" placeholder="Recipient" class="full-width"/>
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="saveTemplate()">Save Template</button>
        </form>
      </div>
    </div>
  </div>  
</div>

